import React, { useState } from 'react';

const Coupon = () => {
    const [showForm, setShowForm] = useState(false);

    const revealForm = event => {
        event.preventDefault();
        setShowForm(true);
    }

    if (showForm) {
        return (
            <form method="get" className="checkout-coupon-form">
                <input type="text" name="coupon" placeholder="Coupon" aria-label="Coupon" />{" "}
                <button type="submit">Apply</button>
            </form>
        );
    }

    return (
        <p><a href="" onClick={revealForm}>Have a coupon?</a></p>
    );
}

export default Coupon;
